import axios from "axios/index";
import store from "../stores/store";

class LoggerService {
    constructor() {
        this.requestHeaders = {
            "Authorization": "",
            "x-api-key": "",
            "Accept": "application/json"
        };
    }

    getRequestHeaders() {
        const state = store.getState();
        this.requestHeaders = {
            "Authorization": state.AuthReducer.userAccessToken,
            "x-api-key": state.AppReducer.applicationConfig.support_anyware_api_key
        };

        return this.requestHeaders;
    }

    createLogger() {
        const self = this;
        return {
            trace(x) {
                self.sendLog(10, x);
            },
            debug(x) {
                self.sendLog(20, x);
            },
            info(x) {
                self.sendLog(30, x);
            },
            warn(x) {
                self.sendLog(40, x);
            },
            error(x) {
                self.sendLog(50, x);
            },
            fatal(x) {
                self.sendLog(60, x);
            }
        };
    }

    sendLog(level, rawData) {
        const state = store.getState();
        const baseUrl = state.AppReducer.applicationConfig.support_anyware_api_url || '';
        const logEndPoint = `${baseUrl.replace(/\/?$/, '/')}commerce_services/ui/logs`;
        const data =
            rawData && typeof rawData === 'object' && !Array.isArray(rawData)
                ? { ...rawData }
                : { message: rawData };
        data.appName = 'secure';
        data.Origin = 'Secure Payment Portal';
        data.Customer_System_Date_Time = new Date();
        if (data.Agent_LDAP && data.Agent_LDAP !== '') {
            data.Agent_LDAP = data.Agent_LDAP.toUpperCase();
        }
        data.level = level;
        axios({
            url: logEndPoint,
            method: 'post',
            headers: {
                ...this.getRequestHeaders(),
                'Content-Type': 'application/json'
            },
            data: data
        }).catch((error) => {
            console.log('Error in logging: ', error);
        });
    }

    saveSplunkLog(data, level) {
        if (level === 'info') {
            this.createLogger().info(data);
        } else if (level === 'error') {
            this.createLogger().error(data);
        } else if (level === 'warn') {
            this.createLogger().warn(data);
        } else if (level === 'fatal') {
            this.createLogger().fatal(data);
        }
    }
}

const loggerService = new LoggerService();
export default loggerService;
